package com.evoapps.evoshift.connectivity

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.browser.window

/**
 * navigator.onLine and the window's online / offline events. Outside a browser (the e2e suite runs
 * the app's DI in Node) the device counts as online.
 */
actual fun platformConnectivityWatcher(): ConnectivityWatcher {
    val inBrowser = js("typeof window !== 'undefined' && typeof navigator !== 'undefined'") as Boolean
    if (!inBrowser) return ManualConnectivity()
    return BrowserConnectivityWatcher()
}

private class BrowserConnectivityWatcher : ConnectivityWatcher {
    private val state = MutableStateFlow(window.navigator.onLine)
    override val isOnline: StateFlow<Boolean> = state.asStateFlow()

    init {
        window.addEventListener("online", { state.value = true })
        window.addEventListener("offline", { state.value = false })
    }
}
